const formatHeader = (text) => {
  if (typeof text !== 'string') {
    throw new Error('Invalid input. The text parameter must be a string.');
  }
  const wordsToIgnore = ['the', 'by', 'to', 'is', 'its', 'through', 'into', 'in', 'at', 'on', 'of', 'for', 'and', 'near', 'a', 'an', 'with', 'de', 'la'];

  const formattedHeader = text.replace(/\b\w+\b/g, (word) => {
    const lowerCaseWord = word.toLowerCase();

    if (wordsToIgnore.includes(lowerCaseWord)) {
      return word;
    }

    return `<span class="formatHeader">${word}</span>`;
  });

  return formattedHeader;
};

export { formatHeader };
